import React from "react";

export default function CongratsOnJoining() {
  return (
    <p className="text-xl mt-0 mb-0">
      Congratulations on joining over <strong>290,000</strong> people who use
      KeepSight for free eye-check reminders.
    </p>
  );
}
